/*@flow*/
import gql from 'graphql-tag';

import type { DocumentNode } from 'graphql';
export default (gql(`
  mutation updateButton(
    $id: ID!
    $name: String!
    $resourceName: String!
    $url: String!
    $fields: [String!]!
    $urlTemplate: String!
    $showOnResourcePage: Boolean
  ) {
    googleFormButtonUpdate(
      input: {
        id: $id
        name: $name
        resourceName: $resourceName
        url: $url
        fields: $fields
        urlTemplate: $urlTemplate
        showOnResourcePage: $showOnResourcePage
      }
    ) {
      success
      record {
        id
        name
        url
      }
      errors
    }
  }
`): DocumentNode);
